<template>
  <div
    class="vh-100 flex flex-column"
    style="padding-right: 6vw;"
  >
    <BgLeaves
      v-if="development.brand === 'lh'"
      :position="[1, 0, 0, 0]"
      :inset="25"
      :trigger="leaves"
    />
    <SliderArrows
      ref="sliderArrows"
      v-show="false"
    />
    <transition-group
      @enter="animEnterSlider"
      @leave="animLeaveSlider"
      tag="div"
      class="w-100 relative vh-100"
      style="flex-grow: 1; margin-top: 9%;"
    >
      <TabContent
        v-touch:swipe.left="swipeLeft"
        v-touch:swipe.right="swipeRight"
        v-show="activeTab === index"
        v-for="(item, index) in specifications"
        :key="index"
        :brand="development.brand"
        :content="item"
      />
    </transition-group>
    <NavSecondary
      :brand="development.brand"
      :icon="icon"
      :items="nav"
      title="Specifications"
    />
  </div>
</template>

<script>
import TabContent from '@/components/property/TabContent'
import NavSecondary from '@/components/property/NavSecondary'
import SliderArrows from '@/components/property/SliderArrows.vue'
import BgLeaves from '@/components/BgLeaves.vue'

import transitions from '../../transitions.js'

export default {
  name: 'Specifications',
  components: {
    TabContent,
    NavSecondary,
    SliderArrows,
    BgLeaves
  },
  props: {
    development: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icon: require('@/assets/img/property-spec.svg'),
      leaves: false
    }
  },
  computed: {
    activeTab () {
      return this.$store.state.activeTab
    },
    prevTab () {
      return this.$store.state.prevTab
    },
    nav () {
      const nav = []
      this.specifications.forEach(element => {
        nav.push(element.title)
      })
      return nav
    },
    specifications () {
      return this.development.specification
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
      vm.$store.commit('setActiveTab', 0)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  },
  mounted () {
    this.$store.commit('setSpecificationLength', this.specifications.length)
  },
  methods: {
    swipeLeft () {
      this.$refs.sliderArrows.next()
    },
    swipeRight () {
      this.$refs.sliderArrows.previous()
    },
    animEnterSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeInRight(el, done)
      } else {
        transitions.fadeInLeft(el, done)
      }
    },
    animLeaveSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeOutLeft(el, done)
      } else {
        transitions.fadeOutRight(el, done)
      }
    }
  }
}
</script>
